// extracted by mini-css-extract-plugin
export var card = "_m6-1";
export var summary = "_m6-0";